import { Decimal } from 'decimal.js';
import { roundToCents } from '../accounts-receivable/round-to-cents.js';
export const roundMoney = roundToCents;
const sum = (values) => [...values].reduce((total, value) => total.plus(value), new Decimal(0));
function enteredDiscountDollars(discount, productSubtotal) {
    if (discount === null)
        return new Decimal(0);
    if (discount.type === 'flat')
        return roundMoney(discount.amount);
    return roundMoney(productSubtotal.times(discount.percent).dividedBy(100));
}
/** The one place an order's money is derived from its lines, entered discount and tax percents. */
export function computeSalesOrderTotals(input) {
    const lineTotals = new Map(input.productLines.map((item) => [
        item.key,
        roundMoney(new Decimal(item.qty).times(item.unitPrice)),
    ]));
    const productSubtotal = sum(lineTotals.values());
    const discountEntered = enteredDiscountDollars(input.discount, productSubtotal);
    const discountApplied = Decimal.min(discountEntered, productSubtotal);
    const shipping = roundMoney(input.shipping ?? 0);
    const taxableBase = productSubtotal.minus(discountApplied);
    const percentSum = sum(input.taxes.map((tax) => new Decimal(tax.percent)));
    // Inclusive prices already contain every rate, so each rate's share is pct / (100 + Σpct).
    const divisor = input.totalIncludesTax ? percentSum.plus(100) : new Decimal(100);
    const taxAmounts = new Map(input.taxes.map((tax) => [
        tax.key,
        roundMoney(taxableBase.times(tax.percent).dividedBy(divisor)),
    ]));
    const totalTax = sum(taxAmounts.values());
    const total = taxableBase.plus(shipping).plus(input.totalIncludesTax ? 0 : totalTax);
    return {
        lineTotals,
        productSubtotal,
        discountEntered,
        discountApplied,
        discountClamped: discountApplied.lessThan(discountEntered),
        shipping,
        taxableBase,
        taxAmounts,
        totalTax,
        taxRatePercent: input.taxes.length > 0 ? percentSum : null,
        total,
    };
}
//# sourceMappingURL=compute-sales-order-totals.js.map